import { render } from "./MvtFinancialStatementList.vue?vue&type=template&id=0bf3766a"
import script from "./MvtFinancialStatementList.vue?vue&type=script&lang=js"
export * from "./MvtFinancialStatementList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__